import { AbstractPlugin as a } from "./ghl-ui.es794.js";
const e = Symbol("onInitialize"), s = Symbol("onDestroy"), o = {};
class l extends a {
  constructor(t) {
    super(t), this.options = {
      ...o,
      ...this.getOptions()
    }, this[e] = this[e].bind(this), this[s] = this[s].bind(this);
  }
  attach() {
    this.draggable.on("draggable:initialize", this[e]).on("draggable:destroy", this[s]);
  }
  detach() {
    this.draggable.off("draggable:initialize", this[e]).off("draggable:destroy", this[s]), this[s]();
  }
  getOptions() {
    return this.draggable.options.focusable || {};
  }
  getElements() {
    return [...this.draggable.containers, ...this.draggable.getDraggableElements()];
  }
  [e]() {
    requestAnimationFrame(() => {
      this.getElements().forEach((t) => r(t));
    });
  }
  [s]() {
    requestAnimationFrame(() => {
      this.getElements().forEach((t) => g(t));
    });
  }
}
const n = [];
function r(i) {
  !i.getAttribute("tabindex") && i.tabIndex === -1 && (n.push(i), i.tabIndex = 0);
}
function g(i) {
  const t = n.indexOf(i);
  t !== -1 && (i.tabIndex = -1, n.splice(t, 1));
}
export {
  l as default
};
